import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { bootstrapSession } from "./lib/api";
import { idbPersister, queryClient } from "./lib/query-client";
// Self-hosted (no Google Fonts CDN call) — this app is meant to keep working
// on a metered classroom connection, and a webfont fetch that hangs would
// block first paint for exactly the users who can least afford it.
//
import "@fontsource-variable/inter";
import "./styles/theme.css";

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root");

// Restore the session from the httpOnly refresh cookie before first paint, so
// a signed-in user reloading the page never sees the login screen flash past.
void bootstrapSession();

createRoot(container).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: idbPersister,
        maxAge: 24 * 60 * 60 * 1000,
        // Bump when the cached shapes change, so an old cache is discarded
        // rather than deserialised into the new code.
        buster: "v1",
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistQueryClientProvider>
  </StrictMode>,
);
